import { z } from 'zod';

export const changePasswordSchemaBase = z.object({
  current_password: z.string().min(1, 'Current password is required.'),
  new_password: z.string().min(1, 'New password is required.'),
  confirm_new_password: z.string().min(1, 'Please confirm the new password.'),
});

export const changePasswordSchema = changePasswordSchemaBase.refine(
  (values) => values.new_password === values.confirm_new_password,
  {
    path: ['confirm_new_password'],
    message: 'New password and confirmation do not match.',
  },
);

export type ChangePasswordSchema = z.infer<typeof changePasswordSchema>;
